import { Component } from '@angular/core';
import { AgentsPerformanceChartHandler } from './performingAgents.handler.';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { DashboardService } from '../../services/dashboard.service';

@Component({
  selector: 'sym-agents-performance-chart',
  templateUrl: './performingAgents.component.html',
  styleUrls: ['./performingAgents.component.scss'],
})
export class AgentsPerformanceChartComponent extends AgentsPerformanceChartHandler {
  constructor(public service: DashboardService, public settingService: SettingService) {
    super(service, settingService);
  }
}
